import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class PicStoriesQueryService {

    public FETCH_PIC_STORIES_DATA: any;

    constructor(public apollo: Apollo) {
        
        this.FETCH_PIC_STORIES_DATA =
            gql`
            query allPictureStories($userId:UUID){                           
                allPicStories(condition:{userId:$userId}) {
                    nodes {
                        id
                        section
                        descFirst
                        descThird
                        descSecond
                        userId
                    }
                }
            }
        `
    }

    FETCH_PIC_STORIES(userId): any {
        return this.apollo
            .watchQuery({
                query: this.FETCH_PIC_STORIES_DATA
                ,
                variables:
                {
                    "userId": userId
                },
                fetchPolicy: 'network-only'
            });
    }

}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/queryFiles/picStories.ts